import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from "@components/custom/Search";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
}

const SearchPeopleComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;

  const inputs = [{
    name : "query",
    label : <FormattedMessage id="app.name" defaultMessage={`Name`}/>,
    type : SearchInputType.TEXT,
    size : 12
  }];
  
  return <Search inputs={inputs} search={search}/>
  
};

export default SearchPeopleComponent;